import React, { useState, useEffect } from "react";
import * as apiUtility from "../../config/APIUtils";
import { Col, Row } from 'react-bootstrap';
import { DataGrid } from '@mui/x-data-grid';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { Divider, IconButton, InputBase, LinearProgress, Paper, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/system';

const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
    '.MuiDataGrid-columnHeadersInner, .MuiDataGrid-footerContainer, .css-rtrcn9-MuiTablePagination-root': {
      backgroundColor: '#007bff', // Header and cell background color\
      fontSize: '1pc',
      color:"white"
    },
  }));

export default function AdminPermissionLogs() {

    var params = "";
    
    const [adminLogsData, setAdminLogsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 25,
      });
     const [totalRows, setTotalRows] = useState(0);
     const [searchText, setSearchText] = useState("");

    useEffect(() => {
        setSearchText("");
        fetchDataFromServer();
    }, [paginationModel.page, paginationModel.pageSize, params])

    const clearFormatting = () => {
        setLoading(true);
        setSearchText("");
        fetchData(paginationModel.page, paginationModel.pageSize, "")
        setLoading(false);
    }

    const handleSearch = (e) => {
        e.preventDefault();
        setLoading(true);
        fetchData(paginationModel.page, paginationModel.pageSize, searchText)
        setLoading(false);
            
    }
    

    const fetchData = async (page, pageSize, searchBy) => {
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.data = {
            "page":page,
            "pageSize":pageSize,
            "search":searchBy
        }
        apiRequest.endPoint = "permissions/fetchAdminLogs";
        await apiUtility.sendAPIDataPOST(apiRequest).then(res => {
            var result =res.data;
            setAdminLogsData(result.data)
            setTotalRows(result.totalCount);
        }).catch(e=>{
            //console.log("Error: ", e.response.data);
            // setDataForErrorPopup(e.response.data);
            // setShowErrorPopup(true);
        })
    };

    const fetchDataFromServer = async () => {
        setLoading(true);
        await fetchData(paginationModel.page, paginationModel.pageSize);
        setLoading(false);
    };

    const captureKeyDown = (e) => {
      if(e.keyCode == 13){
          e.preventDefault();
          handleSearch(e);
       }
  }

    const columns = [
        { field: 'user_id',
            renderHeader: () => (
                <Typography variant="subtitle1">
              {' User ID'}
            </Typography>
          ), flex: 1, filterable: true },
        {
            field: 'fullName',
            flex: 1,
            filterable: true,
            renderHeader: () => (
                <Typography variant="subtitle1">
                  {'Name'}
                </Typography>
              ),
            renderCell: (params) => (
              <Typography variant="caption" align="center">{params.row.fullName}</Typography>
            ),
        },
        {
            field: 'email',
            width: 250,
            filterable: true,
            renderHeader: () => (
                <Typography variant="subtitle1">
                  {'Email ID'}
                </Typography>
              ),
            renderCell: (params) => (
              <Typography variant="caption" align="center">{params.row.email}</Typography>
            ),
        },
        {
            field: 'accessType',
            flex: 1,
            filterable: true,
            renderHeader: () => (
                <Typography variant="subtitle1">
                  {'Type'}
                </Typography>
              ),
            renderCell: (params) => (
              <Typography variant="caption" align="center">{params.row.accessType.charAt(0).toUpperCase() + params.row.accessType.slice(1)}</Typography>
            ),
        },
        {
            field: 'accessId',
            flex: 1,
            filterable: true,
            renderHeader: () => (
                <Typography variant="subtitle1">
                  {'ID'}
                </Typography>
              ),
            renderCell: (params) => (
              <Typography variant="caption" align="center">{params.row.accessId}</Typography>
            ),
        },
        {
            field: 'status',
            renderHeader: () => (
                <Typography variant="subtitle1">
                  {'Status'}
                </Typography>
              ),
            flex: 1,
            renderCell: (params) => (
              <Typography variant="caption" align="center">{params.row.status}</Typography>
            ),
        },
        { field: 'action', 
        renderHeader: () => (
            <Typography variant="subtitle1">
              {'Action'}
            </Typography>
          ),
        flex: 1,
        filterable: true,
        renderCell: (params) => (
             ( <Typography variant="caption" align="left">{params.row.action}</Typography>)
        )},

        { field: 'date', 
        renderHeader: () => (
            <Typography variant="subtitle1">
              {'Date'}
            </Typography>
          ),
        flex: 1,
        renderCell: (params) => (
             ( <Typography variant="caption">{params.row.date}</Typography>)
        )}
    ];

    
    
    
    return (
        <div className='org-container' disableEnforceFocus>
            <Row>
              <Row>
              <Typography variant="h6" display="block" align="center" color={"primary"} >Admin Permission Activity Log</Typography>
              <br></br>
                <br></br>
              </Row>
                <Col xs={12} md={6}>
                
                    {/* <Button variant='warning' style={{margin:"1%"}} onClick={exportInExcel}>Export to Excel</Button> */}
                </Col> 
            
                <Col xs={12} md={6}>
                  <Paper component="form" variant="outlined"
                        sx={{float:"right", display: 'flex', marginBottom:"4px",alignItems: 'center', width: 450 }}
                        >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Search by Firstname or Lastname"
                            inputProps={{ 'aria-label': 'search by last or first' }}
                            value={searchText}
                            onChange={(e) => {
                                setSearchText(e.target.value);
                            }}
                            onKeyDown={captureKeyDown}
                        />
                        <Tooltip variant="contained" title="Search" disableRipple>
                            <IconButton type="button" onClick={handleSearch} sx={{ p: '10px' }} aria-label="search">
                                <ManageSearchIcon />
                            </IconButton>
                        </Tooltip>
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <Tooltip variant="contained" title="Reset Grid" disableRipple>
                            <IconButton color="primary" onClick={clearFormatting} sx={{ p: '10px' }} aria-label="directions">
                                <ClearAllIcon />
                            </IconButton>
                        </Tooltip>    
                        </Paper>
                </Col>
                
            </Row>

            <CustomDataGrid
                loading={loading}
                rowCount={totalRows}
                rows={adminLogsData}
                columns={columns}
                slots={{
                    loadingOverlay: LinearProgress
                  }}
                pageSizeOptions={[10, 25, 50, 100]}
                paginationMode="server"
                componentsProps={{ panel: { disablePortal: true } }}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    setRowSelectionModel(newRowSelectionModel);
                  }}
                rowSelectionModel={rowSelectionModel}
                getRowId={(row) => row._id}
                sx={{  p: 0,borderRadius: "0" }}
                autoHeight={true} // Set automatic height
                getRowHeight={() => 'auto'}
                
            />

        </div>);
}